import type { VoidFunctionComponent } from 'react';
import { Icon, NavigationButton, icons } from '../generic';

import styles from './IssueOverview.module.less';

const NoProjectsContent: VoidFunctionComponent = () => {
  return (
    <div className={styles.noProjects}>
      This is where we&apos;ll show you an overview of issues we&apos;ve detected.
      <br />
      Get started by importing your first project.

      <div className={styles.addProjectsButton}>
        <NavigationButton to="/projects/import" size="medium">
          <Icon icon={icons.plus} /> Add Projects
        </NavigationButton>
      </div>
    </div>
  );
};

export default NoProjectsContent;
